// *******************************************************************************
// 1.0 - Form Validation
// *******************************************************************************
let succesfull = false;
document.addEventListener('DOMContentLoaded', () => {
  const formModule = document.querySelector('.inquiry-modal');
  const formElem = document.getElementById('inquiry-modal__form');

  if (formElem) {
    const recaptchaKey = formElem.querySelector('.g-recaptcha').getAttribute('data-sitekey');

    const fv = FormValidation.formValidation(formElem, {
      locale: 'sl_SI',
      localization: FormValidation.locales.sl_SI,
      fields: {},
      plugins: {
        message: new FormValidation.plugins.Message({
          container: (field, element) => element.closest('.mod-input,.checkbox,.dropdown'),
        }),
        declarative: new FormValidation.plugins.Declarative({
          html5Input: true,
        }),
        trigger: new FormValidation.plugins.Trigger(),
        submitButton: new FormValidation.plugins.SubmitButton(),
      },
    })
      .on('core.element.validated', (e) => {
        // e.element presents the field element
        // e.valid indicates the field is valid or not

        // Get the field value
        const value = fv.getElementValue(e.field, e.element);
        const container = FormValidation.utils.closest(e.element, '.mod-input,.checkbox,.dropdown');
        if (!e.valid && value === '') {
          FormValidation.utils.classSet(container, {
            'is-validation-failed': true,
          });
        } else {
          FormValidation.utils.classSet(container, {
            'is-validation-failed': false,
          });
        }
      })
      .on('core.form.valid', () => {
        grecaptcha.ready(() => {
          grecaptcha.execute(recaptchaKey, { action: 'sendInquiry' }).then((token) => {
            const formData = {};
            const formDataImage = new FormData();
            let infoStr = '';
            const form = document.querySelector('.inquiry-modal__form form');
            const info = document.querySelectorAll('.inquiry-modal__info-item p');
            const loader = formElem.querySelector('.inquiry-loader');
            const button = formElem.querySelector('.btn');
            const formAlertError = formElem.querySelector('.form-component__alert-error');
            loader.style.display = 'block';

            form.querySelectorAll('input, textarea').forEach((input) => {
              if (input.type === 'radio') {
                if (input.checked) {
                  formData[input.name] = input.id.trim();
                }
              } else if (input.type === 'checkbox') {
                if (input.checked) {
                  formData[input.name] = input.value.trim();
                }
              } else {
                formData[input.name] = input.value.trim();
              }
            });
            info.forEach((item) => {
              infoStr += `${item.innerHTML} `;
            });
            formData.info = infoStr;

            formDataImage.append('action', formData.action);
            formDataImage.append('token', token);
            formDataImage.append('inputs', JSON.stringify(formData));
            formDataImage.append('lang', localData.lang);
            formDataImage.append('id', localData.id);
            formDataImage.append('nonce', formData.nonce);
            axios
              .post(localData.siteURL, formDataImage, {
                headers: {
                  'Content-Type': 'multipart/form-data',
                },
              })
              .then((response) => {
                if (response.data.data.status === 200) {
                  formModule.classList.add('show-thankyou');
                  document.querySelector('.inquiry-modal__thankyou h2').innerText = response.data.data.msg;
                  succesfull = !!response.data.data.thankyou;
                  loader.style.display = 'none';
                  button.style.display = 'inline-flex';
                }
              })
              .catch((error) => {
                console.error(error);
                loader.style.display = 'none';
                formAlertError.classList.remove('hide');
                formAlertError.innerHTML = error.response.data.data.msg;
              });
          });
        });
      });
  }
});

// *******************************************************************************
// 2.0 - Close Inquiry-modal
// *******************************************************************************
const removeThankYouModal = () => {
  if (succesfull === false) {
    setTimeout(() => {
      document.querySelector('.inquiry-modal').classList.remove('show-thankyou');
    }, '250');
  }
  toggleBodyScrollLock(false);
};

attachEvent('.inquiry-modal__close', 'click', (ev) => {
  const parentElem = ev.target.closest('.inquiry-modal');
  parentElem.classList.remove('is-open-modal');
  removeThankYouModal();
});

// Close Modal When Escape Key Press
document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') {
    document.querySelectorAll('.inquiry-modal.is-open-modal').forEach((el) => {
      el.classList.remove('is-open-modal');
      removeThankYouModal();
    });
  }
});

// Close Inquiry Modal When Click Out
document.addEventListener('click', (evt) => {
  const modalContainer = document.querySelector('.inquiry-modal__inner');
  let targetElement = evt.target; // clicked element

  do {
    if (targetElement === modalContainer) {
      return;
    }
    targetElement = targetElement.parentNode;
  } while (targetElement);

  document.querySelectorAll('.inquiry-modal').forEach((el) => {
    el.classList.remove('is-open-modal');
    removeThankYouModal();
  });
});
